import React, { Component } from 'react';
import PropTypes from 'prop-types';
import style from 'dom-helpers/style';
import Transition from 'react-transition-group/Transition';

const collapseStyles = {
  exited: { display: 'none' },
  exiting: {
    height: 0,
    overflow: 'hidden',
    transitionProperty: 'height, visibility',
  },
  entering: {
    height: 0,
    overflow: 'hidden',
    transitionProperty: 'height, visibility',
  },
  entered: { display: 'block' },
};

export class Collapse extends Component {
  getHeight = (elem) => {
    const value = elem.offsetHeight;
    const margins = ['marginTop', 'marginBottom'];

    return (
      value +
      parseInt(style(elem, margins[0]), 10) +
      parseInt(style(elem, margins[1]), 10)
    );
  };

  /* -- Expanding -- */
  handleEnter = (elem) => {
    if (elem.style) {
      elem.style.height = '0'; // eslint-disable-line no-param-reassign
    }
  };

  handleEntering = (elem) => {
    if (elem.style) {
      elem.style.height = `${elem.scrollHeight}px`; // eslint-disable-line no-param-reassign
    }
  };

  handleEntered = (elem) => {
    if (elem.style) {
      elem.style.height = null; // eslint-disable-line no-param-reassign
    }
  };

  /* -- Collapsing -- */
  handleExit = (elem) => {
    if (elem.style) {
      elem.style.height = `${this.getHeight(elem)}px`; // eslint-disable-line no-param-reassign
      elem.offsetHeight; // eslint-disable-line no-unused-expressions
    }
  };

  handleExiting = (elem) => {
    if (elem.style) {
      elem.style.height = '0'; // eslint-disable-line no-param-reassign
    }
  };

  defaultStyle = (duration) => ({
    transition: `all ${duration}ms ease-in-out`,
    position: 'absolute',
    top: 0,
  });

  render() {
    const { in: inProp, children, duration, timeout } = this.props;
    return (
      <Transition
        in={inProp}
        timeout={timeout}
        onEnter={this.handleEnter}
        onEntering={this.handleEntering}
        onEntered={this.handleEntered}
        onExit={this.handleExit}
        onExiting={this.handleExiting}
      >
        {(state) => (
          <div
            style={{
              ...this.defaultStyle(duration),
              ...collapseStyles[state],
            }}
          >
            {children}
          </div>
        )}
      </Transition>
    );
  }
}

Collapse.defaultProps = {
  timeout: 300,
  duration: 300,
};

Collapse.propTypes = {
  in: PropTypes.any,
  timeout: PropTypes.number,
  duration: PropTypes.number,
  children: PropTypes.any,
};

export default Collapse;
